import { deviceDescriptorHeaders, deviceIdHeaders } from "@/platform/api/device-id"
import { identityHeaders } from "@/platform/api/identity"
import type { CacheIntent, Identity } from "@/platform/api/identity"
import { getBrowserSessionId } from "@/platform/session/auth/get-session-cookie-client"

const dynamicDefaults = (hasDeviceId: boolean): Record<string, string> => ({
  "session-id": getBrowserSessionId(),
  "x-device-platform": "web",
  ...deviceDescriptorHeaders,
  ...(hasDeviceId ? {} : deviceIdHeaders()),
})

export const requestHeaders =
  (identity: () => Identity, extra: Record<string, string> = {}) =>
  (intent: CacheIntent): Record<string, string> => {
    const headers = identityHeaders(identity(), intent)
    return intent === "dynamic" ? { ...dynamicDefaults(headers["x-device-id"] !== undefined || extra["x-device-id"] !== undefined), ...headers, ...extra } : headers
  }
